import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { images } from '../../../../Constants/ImageUrls';
import { getScreenName } from '../../../../Utils/helper';
import { getRouterLocale } from '../../../../Utils/i18Utils/constant';
import AddToCartCta from '../../../StoreCategoryPage/SubCategoryProducts/AddToCartCta';
import AnchorCoverTag from '../../../StoreHomePage/AnchorCoverTag';
import { ProductCardStyle, ProductFlag, RatingSectionNew } from './styled';
import { queryParamHandling } from '../../../../Utils/productPageUtils';
import ProductPriceAB from '../../../../Utils/ProductPriceAB';
import { fireEvent } from '../../../../Utils/fireEvent';

const ProductCardNew = (props) => {
  const {
    productInfo,
    horizontal,
    categoryId,
    sectionId,
    sectionName,
    singleProduct,
  } = props;
  const [activeIndex, setActiveIndex] = useState(null);
  const router = useRouter();
  const callbackFunction = (index, deeplinkValue) => {
    setTimeout(() => {
      fireEvent({
        category: 'clicked_card_in_general_screen',
        id: categoryId,
        section_id: sectionId,
        section_name: sectionName,
        card_id: productInfo?._id,
        card_name: productInfo?.name?.slice(0, 99),
        screen_name: getScreenName(),
        deeplink_value: deeplinkValue,
      });
      const { addParams, newUrl } = queryParamHandling(deeplinkValue);
      router.push(`${newUrl}` + addParams, '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
  };

  const productClickHandler = () => {
    setActiveIndex(productInfo?._id);
    setTimeout(() => {
      setActiveIndex(null);
    }, 1000);
  };
  return (
    <ProductCardStyle
      onClick={() => {
        productClickHandler();
      }}
      className={`${activeIndex == productInfo?._id ? 'active' : ''} ${
        singleProduct ? 'singleProduct' : ''
      }`}
      extraPadding={productInfo?.ctaNotAdded?.text?.length > 0}
      horizontal={horizontal}
      singleProduct={singleProduct}
      category={true}
    >
      <AnchorCoverTag
        url={productInfo?.webUrl}
        callbackFunction={callbackFunction}
      >
        <div className="imgWrapper">
          {productInfo?.textFlag?.text?.length > 0 && (
            <ProductFlag flagData={productInfo?.textFlag}>
              {productInfo?.textFlag?.text}
              <span></span>
            </ProductFlag>
          )}

          <Image
            src={productInfo?.image}
            alt=""
            loading="lazy"
            placeholder="blur"
            blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN88+F3PQAI/wNYdVMfwAAAAABJRU5ErkJggg"
            quality={90}
            fill
            sizes="67vw"
          />
        </div>
        <div className="detailsSection">
          <p className="productName">{productInfo?.name}</p>

          <div className="snippetSection">
            {productInfo?.productSnipitVariants?.map((snippet, index) => {
              return (
                <p key={productInfo?._id + index} className="snippetText">
                  {snippet?.text}
                </p>
              );
            })}
          </div>
          <RatingSectionNew>
            <img src={images.newFilledStar} alt="" />
            <p>{productInfo?.starRating}</p>
            <span>{productInfo?.starRatingSubScript}</span>
          </RatingSectionNew>
          {productInfo?.showComboStrip && (
            <div
              className="comboSavingText"
              dangerouslySetInnerHTML={{
                __html: productInfo?.comboSavings + '<span></span>',
              }}
            ></div>
          )}
          {/* <PriceDetailNew singleProduct={singleProduct}> */}
          <ProductPriceAB
            priceData={productInfo}
            classString="sellingPrice"
            classStringStrike="strikePrice"
            classStringDisc="discount"
            singleProduct={singleProduct}
          />
          {/* {productInfo?.price !== productInfo?.strikePrice ? (
                            <p className="strikePrice">
                                {productInfo?.strikePrice}
                            </p>
                        ) : null}
                        <p className="discount">{productInfo?.discount}</p> */}
          {/* </PriceDetailNew> */}

          {true && (
            <AddToCartCta
              product={productInfo}
              section={'section'} //
              category_name={'category_name'} //
              setAddedToCart={null} //
              parentTag={'parentTag'} //
              smallButton={true}
              isCategoryPage={true}
              newUI={true}
              singleProduct={singleProduct}
            />
          )}
        </div>
      </AnchorCoverTag>
    </ProductCardStyle>
  );
};

export default ProductCardNew;
